(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["celeb-products-modern-minimal"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var forms = document.querySelectorAll('.add-to-cart-form');
  
  forms.forEach(function(form) {
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      
      var button = form.querySelector('.add-to-cart');
      var variantSelect = form.querySelector('.product-variant');
      var quantityInput = form.querySelector('.product-quantity');
      
      var formData = {
        'items': [{
          'id': variantSelect.value,
          'quantity': quantityInput.value
        }]
      };
      
      button.disabled = true;
      button.textContent = 'Adding...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        button.textContent = 'Added!';
        setTimeout(() => {
          button.textContent = 'Add to Cart';
          button.disabled = false;
        }, 2000);
        
        fetch('/cart.js').then(response => response.json()).then(cart => {
          console.log('Cart updated:', cart);
        });
      })
      .catch(error => {
        console.error('Error:', error);
        button.textContent = 'Error';
        button.disabled = false;
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
